import React from 'react';
import PropTypes from 'prop-types';

import Loader from 'react-loader-spinner';

const ContantChangePassword5 = props => {
  const { loading, error } = props;

  if (loading) {
    return (
      <div style={{ width: '100%', maxWidth: '230px', margin: '0 auto' }}>
        <Loader type="Plane" color="#fcfcfc" height={100} width={100} />
      </div>
    );
  }

  if (error) {
    return <div>Ocorreu um erro na alteração da senha, tente novamente mais tarde.</div>;
  }

  return <div>Sua senha foi redefinida.</div>;
};

ContantChangePassword5.defaultProps = {
  loading: false,
  error: false,
};

ContantChangePassword5.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.bool,
};

export default ContantChangePassword5;
